// @core/stores/project/ProjectAnalyticStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { projectApi } from '@core/api';
import type {
  CumulativeFlowResponse,
  ProjectStatsResponse,
  VelocityResponse,
} from '@core/types/project';

class ProjectAnalyticStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get cumulative flow diagram
   */
  async GetCumulativeFlow(project_id: string): Promise<CumulativeFlowResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await projectApi.GetCumulativeFlow(project_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get project statistics
   */
  async GetProjectStats(project_id: string): Promise<ProjectStatsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await projectApi.GetProjectStats(project_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get velocity chart
   */
  async GetVelocity(project_id: string): Promise<VelocityResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await projectApi.GetVelocity(project_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const projectAnalyticStore = new ProjectAnalyticStore();
